import { Dialog } from '@/components/UI/Dialog'
import { HtmlContent } from '@/components/UI/HtmlContent'
import React, { memo } from 'react'

type Props = {
  title: string
  description: string
  isOpen: boolean
  onClose: () => void
}

/** キャンペーン概要ダイアログ */
export const DialogCampaignDescription = memo(({ title, description, isOpen, onClose }: Props) => {
  return (
    <Dialog selectorState={isOpen} closeFunc={onClose} title={title}>
      <HtmlContent html={description} variant="body1" className="mt-4 text-gray-700 whitespace-pre-wrap" />
    </Dialog>
  )
})
